import Board from '../entities/Board';
import Group from '../entities/Group';

const readBoardsByGroup = (group: Group) => ({
  type: 'READ_BOARDS_BY_GROUP',
  group
});

const successReadBoardsByGroup = (boards: Board[]) => ({
  type: 'SUCCESS_READ_BOARDS_BY_GROUP',
  boards
});

const readBoardsDiff = () => ({
  type: 'READ_BOARDS_DIFF'
});

const successReadBoardsDiff = (boards: Board[]) => ({
  type: 'SUCCESS_READ_BOARDS_DIFF',
  boards
});

const createBoard = (board: Board) => ({
  type: 'CREATE_BOARD',
  board
});

const successCreateBoard = (board: Board) => ({
  type: 'SUCCESS_CREATE_BOARD',
  board
});

const updateBoard = (board: Board) => ({
  type: 'UPDATE_BOARD',
  board
});

const successUpdateBoard = (board: Board) => ({
  type: 'SUCCESS_UPDATE_BOARD',
  board
});

const destroyBoard = (board: Board) => ({
  type: 'DESTROY_BOARD',
  board
});

const successDestroyBoard = (board: Board) => ({
  type: 'SUCCESS_DESTROY_BOARD',
  board
});

export {
  readBoardsByGroup,
  successReadBoardsByGroup,
  readBoardsDiff,
  successReadBoardsDiff,
  updateBoard,
  successUpdateBoard,
  destroyBoard,
  successDestroyBoard,
  createBoard,
  successCreateBoard
};



// WEBPACK FOOTER //
// ./src/actions/board.ts